import { create } from 'zustand';

const useSubtitleValidationStore = create((set, get) => ({
  validatingVideos: {},
  
  startValidating: (videoName) => {
    const current = get().validatingVideos;
    set({ validatingVideos: { ...current, [videoName]: true }});
  },
    
  finishValidating: (videoName) => {
    const current = get().validatingVideos;
    const newValidating = { ...current };
    delete newValidating[videoName];
    set({ validatingVideos: newValidating });
  },
    
  isAnyValidating: () => {
    return Object.values(get().validatingVideos).some(Boolean);
  },
  
  getValidatingCount: () => {
    return Object.values(get().validatingVideos).filter(Boolean).length;
  }
}));

export default useSubtitleValidationStore;